import { EventHooks } from '../../../hooks/index';
import {
  CompanyIncorporationEvent,
  EventTypeBackend,
  EventUnionWithPermissions,
  isPendingLifecycleStatus,
  SortByType,
} from '../../../types/events.types';

type CompanyIncorporationEventWithPermissions = Extract<
  EventUnionWithPermissions,
  { type: EventTypeBackend.COMPANY_INCORPORATION }
>;

export const useCompanyIncorporationEvent = ({
  companyId,
  enabled = true,
}: {
  companyId: string;
  enabled?: boolean;
}) => {
  const { events, isLoading } = EventHooks.useEvents({
    companyId,
    typesFilter: [SortByType.COMPANY_INCORPORATION],
    enabled,
  });

  const companyIncorporationEvent = events.find(
    (event): event is CompanyIncorporationEventWithPermissions =>
      event.type === EventTypeBackend.COMPANY_INCORPORATION &&
      !isPendingLifecycleStatus(event.lifecycleStatus) &&
      Array.isArray((event as CompanyIncorporationEvent).items),
  );

  return {
    companyIncorporationEvent,
    isLoading,
  };
};
